<template>
  <div class='module-form__container'>
    <div class='kd-panel__header-no-underline' v-if='!id'>
      <div class="kd-panel-form__header_title">{{Kadenze.I18n.t('learning_module.new.new_module')}}</div>
      <div class="kd-panel-form__header_subtitle">{{Kadenze.I18n.t('learning_module.new.add_a_new_module_to_your_learning_path')}}</div> </div>

    <div class='kd-panel__content'>
      <div class="kl-form">
        <div class="kl-form__row">
          <div class="kl-form__col module__name">
            <kd-input-container>
              <label>{{Kadenze.I18n.t('file_preview.name')}}</label>
              <kd-input v-model="name" />
            </kd-input-container>
          </div>
        </div>
        <div class="kl-form__row"
             v-if='learningModule.has_achievements'>
          <div class="alert alert-attention">
            <p>
              Some students have already completed this learning module. Please use caution when modifying the required activities as it may have unintended consequences.
            </p>
          </div>
        </div>
        <div class="kl-form__row">
          <div class="kl-form__col kl-form__col--grow">
            <label class="typo__subhead--reg">{{Kadenze.I18n.t('dict.activities')}}</label>
          </div>
        </div>
        <div class="kl-form__row">
          <div class="kl-form__col kl-form__col--grow">
            <activities-table
              @add='onAdd'
              @edit='onEdit'
              @delete='onDelete'
              :activities='activities'
              :modulables='modulables'
              :moduleSaved='learningModule.id'
            />
          </div>
        </div>
        <div class="kl-form__section"
             :class="[(modules.filter(i => i.id != id).length != 0) ? '' : 'is-disabled']">
          <div class="kl-form__row">
            <div class="kl-form__col kl-form__col--grow">
              <label class="typo__subhead--reg">{{Kadenze.I18n.t('dict.prerequisites')}}</label>
            </div>
          </div>
          <div class="kl-form__row module__prereq-row" v-for='(prerequisite, i) in prerequisite_ids' :key='i'>
            <div class="kl-form__col kl-form__col--grow" v-if='prerequisite !== null'>
              <a class="module__remove-prereq" href="javascript:;" @click='prerequisite_ids.splice(i, 1)'>
                <i class="kf kf-x"></i>
              </a>
              <selectpicker
                title='Select Module'
                :options="modules.filter((m) => m.id !== id)"
                :value='prerequisite_ids[i]'
                @input='bindPrereq($event, i)'
                optionsValue='id'
                optionsText='title'
              />
            </div>
          </div>
          <div class="kl-form__row">
            <div class="kl-form__col kl-form__col--grow">
              <a
                class="module__add-prereq"
                @click='prerequisite_ids.push(-1)'
                href='javascript:;'
              >
                <i class="kf kf-plus"></i>
                {{Kadenze.I18n.t('learning_module.add_activity.add_prerequisite')}}
              </a>
            </div>
          </div>
        </div>
        <div class="kl-form__row--padding">
          <div class="kl-form__col">
            <checkbox v-model='useBadge' v-bind:label="Kadenze.I18n.t('learning_module.issue_badge_label')"></checkbox>
          </div>
        </div>
        <div class="kl-form__row" v-if='useBadge'>
          <selectpicker
            :options="modulables['badges']"
            v-bind:title="Kadenze.I18n.t('learning_module.select_badge')"
            v-model='badge_id'
            optionsValue='id'
            optionsText='title'
          />
        </div>
      </div>
    </div>
    <div class='kd-panel__footer--full w-hr'>
      <div class="kd-panel__footer_primary-btns">
        <a class="inline-block-link--del typo__body--reg"
           href="javascript:;"
           @click='$emit("cancel")'>
          {{Kadenze.I18n.t('dict.cancel')}}
        </a>
        <a class="inline-block-link typo__body--reg"
          :class='[valid ? "" : "is-disabled"]'
          href="javascript:;"
          @click='save'>
          {{Kadenze.I18n.t('dict.save')}}
        </a>
      </div>
    </div>
    <generic-modal v-if='showNewActivityForm'
                   v-bind:modal_title = "Kadenze.I18n.t('learning_module.add_activity.heading')"
                   v-bind:modal_description="Kadenze.I18n.t('learning_module.add_activity.description')"
                   :config="{ underline_header: false, show_close_btn: false, use_template_footer: false }"
                   @close='showNewActivityForm = false'>
      <template slot='body'>
        <new-activity-form @close='showNewActivityForm = false'
                           @save='saveNewActivity'
                           v-bind="{ modulables, currentActivity: currentlyEditingActivity }" />
      </template>
    </generic-modal>
  </div>
</template>

<script>
import ActivitiesTable from './activities-table.vue';
import NewActivityForm from './new-activity-form.vue';

export default {
  props: {
    courseId: {
      type: String
    },
    learningModule: {
      type: Object
    },
    modulables: {
      type: Object
    },
    modules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      panelProps: {
        title: 'New Module',
        subtitle: 'Add a new Module to your learning path' ,
        headerClass: 'kd-panel__header-no-underline'
      },
      showNewActivityForm: false,
      name: '',
      id: null,
      activities: [],
      prerequisite_ids: [],
      currentlyEditingActivity: null,
      currentlyEditingIndex: null,
      useBadge: false,
      badge_id: null,
      seen_modules: [],
    };
  },
  components: {
    NewActivityForm,
    ActivitiesTable
  },
  mounted() {
    console.log('Instructor Module Form VM mounted');
    if ( this.learningModule ) {
      this.bindData(this.learningModule);
    }
  },
  computed: {
    valid() {
      return !_.isEmpty(this.activities) &&
        !_.isEmpty(this.name)
    },
    moduleHash() {
      const h = {}
      this.modules.forEach((m) => {
        h[m.id] = m;
      })
      return h;
    }
  },
  watch: {
    learningModule() {
      this.bindData(this.learningModule);
    },
    prerequisite_ids() {
    }
  },
  methods: {
    bindData(lm) {
      this.id = lm.id;
      this.order = lm.order;
      this.name = lm.title;
      this.activities = lm.activities || [];
      this.prerequisite_ids = lm.prerequisite_ids || [];
      this.badge_id = lm.badge_id;
      this.useBadge = Boolean(this.badge_id);
    },
    saveNewActivity(data) {
      if ( this.currentlyEditingIndex !== null ) {
        this.$set(this.activities, this.currentlyEditingIndex, data);
      } else {
        this.activities.push(data);
      }
      if ( this.id ) {
        this.save(false);
      }
    },
    onAdd() {
      this.currentlyEditingActivity = null;
      this.currentlyEditingIndex = null;
      this.showNewActivityForm = true;
    },
    onEdit(index) {
      this.showNewActivityForm = true;
      this.currentlyEditingActivity = this.activities[index];
      this.currentlyEditingIndex = index;
    },
    bindPrereq($event, i) {
      if ( $event !== null ) {
        this.prerequisite_ids[i] = $event
      }
    },
    onDelete(index) {
      if (this.id) {
        this.activities[index]._destroy = true;
        this.save(false);
      } else {
        this.activities.splice(index, 1)
      }
    },
    save(shouldClose = true) {
      if ( this.hasCircularPrereqs() ) {
        return new Kadenze.Notice.error({
          title: "Uh Oh! Circular Prerequisites Detected",
          message: "This learning module has one or more circular prerequisites and cannot be saved."
        });
      }

      this.activities.forEach((act, i) => {
        this.$set(act, 'order', i + 1)
      })

      let url;
      let type;
      if (this.id) {
        url = Kadenze.Routes.course_learning_module_path(this.courseId, this.id);
        type = 'PATCH';
      } else {
        url = Kadenze.Routes.course_learning_modules_path(this.courseId);
        type = 'POST';
      }
      new Kadenze.AjaxRequest({
        url,
        type,
        loadingIndicator: true,
        data: {
          learning_module: {
            title: this.name,
            prerequisite_ids: this.prerequisite_ids,
            course_id: this.courseId,
            activities_attributes: this.activities,
            prerequisite_ids: this.prerequisite_ids,
            badge_id: this.badge_id
          }
        }
      }).success(({learning_module}) => {
        this.$emit('update', learning_module, shouldClose)
      })
    },
    hasCircularPrereqs(prereqs) {
      this.seen_modules = [];
      if (this.id && !_.isEmpty(this.prerequisite_ids)) {
        return this.detect({
          id: this.id,
          prerequisite_ids: this.prerequisite_ids
        });
      }

      return false;
    },
    detect(module) {
      if (module.id && this.seen_modules.indexOf(module.id) !== -1) {
        return true;
      }

      this.seen_modules.push(module.id)
      for (const id of module.prerequisite_ids || []) {
        if (this.detect(this.moduleHash[id])) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>

